<template>
    <v-container fluid pt-10>
        <v-layout justify-center>
            <v-flex xs12 sm6 md9 >
                <v-card style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
                    <v-toolbar flat>
                        {{ tituloTela }}
                        <v-spacer></v-spacer>
                        <v-btn class="ma-1" v-if="canAdd" id="addRegistro" fab small dark color="#10303D" @click="$emit('add')">
                            <v-icon dark small>fas fa-plus</v-icon>
                        </v-btn>
                        <v-btn class="ma-1" v-if="canDelete" id="deleteRegistro" fab small dark color="#FF5252" @click="$emit('delete')">
                            <v-icon dark small>fas fa-trash-alt</v-icon>
                        </v-btn>
                        <v-btn class="ma-1" v-if="canSearch" id="searchRegistro" fab small dark color="info" @click="$emit('search')">
                            <v-icon dark small>fas fa-search</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <slot/>
                </v-card>
                <AppLoaderBlockCard :overlay="isLoading"/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import AppLoaderBlockCard from '@/components/layout/AppLoaderBlockCard.vue'

export default {
    components: {
        AppLoaderBlockCard
    },
    props: {
        isLoading: Boolean,
        tituloTela: String,
        canAdd: {
            type: Boolean,
            default: true
        },
        canDelete: {
            type: Boolean,
            default: true
        },
        canSearch: {
            type: Boolean,
            default: true
        },
    }
}
</script>

<style>
    .margin {
        margin-bottom: 1%;
    }
</style>

